import { useTracking } from 'lib/analytics/track'
import { MouseEventHandler } from 'react'

const buildEmptyPayload = (_link: HTMLAnchorElement) => ({})

export const useDynamicLinkTracking = (
  buildPayload = buildEmptyPayload,
  linkSelector = 'a'
) => {
  const tracker = useTracking()
  const handleLinkClicked: MouseEventHandler<HTMLParagraphElement> = (
    event
  ) => {
    const clickedElement = event.target as Element
    const clickedLinkElement = clickedElement.closest(
      linkSelector
    ) as HTMLAnchorElement

    if (clickedLinkElement) {
      tracker.trackEvent(buildPayload(clickedLinkElement))
    }
  }

  return { handleLinkClicked, tracker }
}
